import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('vision_benefits_set_review', '/vision_benefits_set_reviews', 'review')
const reducer = generator.generate()

export default reducer
